var map = {
	"./bmp": 414,
	"./bmp.js": 414,
	"./gif": 415,
	"./gif.js": 415,
	"./jpg": 416,
	"./jpg.js": 416,
	"./png": 417,
	"./png.js": 417,
	"./psd": 418,
	"./psd.js": 418,
	"./svg": 419,
	"./svg.js": 419,
	"./tiff": 420,
	"./tiff.js": 420,
	"./webp": 421,
	"./webp.js": 421
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 412;


//////////////////
// WEBPACK FOOTER
// ./~/markdown-it-imsize/lib/imsize/types ^\.\/.*$
// module id = 412
// module chunks = 0